import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconOptions = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" d="M8 38a6 6 0 1 0 0-12 6 6 0 0 0 0 12M32 38a6 6 0 1 0 0-12 6 6 0 0 0 0 12M56 38a6 6 0 1 0 0-12 6 6 0 0 0 0 12" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconOptions.displayName = 'IconOptions';